<template>
  <div class="wrap">
    <div v-if="hasError === true">
      <div class="title">本登録に失敗しました。</div>
      <div class="err-msg-wrap">
        <div>URLに間違いがない場合、以下の可能性が考えられます。</div>
        <ul>
          <li>本登録用URLの有効期限が切れている</li>
          <li>既に本登録が完了している</li>
          <li>システムエラー</li>
        </ul>
        <div>ログイン画面からログインできない場合は、お手数ですが再度新規登録のお手続きをお願いいたします。</div>
      </div>
      <div class="btn-wrap">
        <button class="btn to-login-btn" @click="$router.replace({ name: 'login' })">
          ログイン画面へ
        </button>
      </div>
    </div>
    <div v-else-if="hasError === false">
      <div class="title">本登録が完了いたしました。</div>
      <div class="btn-wrap">
        <button class="btn to-login-btn" @click="$router.replace({ name: 'login' })">
          ログイン画面へ
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegistrationComplete',
  data() {
    return {
      hasError: null
    }
  },
  created(){
    const args = {
      onetime_token: this.$route.params.onetimeToken,
      __apiOptions: { noErrorDialog: true },
    }
    this.$store.dispatch('api/registerKuraemonId', args).then(() => {
      this.hasError = (this.$store.getters['api/apiError'] ? true : false)
    })
  }
}
</script>

<style scoped>
.wrap {
  padding: 2rem;
  margin: auto;
  width: 500px;
}
.title {
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 1rem;
}
.btn-wrap {
  text-align: center;
  margin-top: 10rem;
}
.btn {
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
  width: 17rem;
}
.to-login-btn {
  background-color: #333;
  color: white;
}
@media (max-width: 1024px) {
  .wrap {
    max-width: 500px;
    width: 80%;
  }
}

</style>